import { Stack } from '@prenuvo/halo';

import { PreferenceRadio } from './preference-radio.component';
import { PreferenceRadioOption } from './preferences.model';

interface PreferenceRadioGroupProps {
  disabled?: boolean;
  onChange: (value: string) => void;
  options: PreferenceRadioOption[];
  value?: string;
}

export function PreferenceRadioGroup({
  disabled = false,
  onChange,
  options,
  value,
}: PreferenceRadioGroupProps) {
  return (
    <Stack className="shrink-0" gap={0} role="radiogroup">
      {options.map((option, index) => (
        <PreferenceRadio
          key={option.value}
          disabled={disabled}
          isFirst={index === 0}
          isLast={index === options.length - 1}
          isSelected={option.value === value}
          onChange={onChange}
          option={option}
        />
      ))}
    </Stack>
  );
}
